skrilla.directive('queryProductFeeReports', function () {
    return {
        templateUrl: 'directives/productFeeReports/queryProductFeeReports.html',
        scope: {
            reports: "=",
            key: "=",
            queryKey: "=",
            selectedReports: "=" //the output of rows selected with checkboxes
        },
        controller: async function ($scope, searchService, queryService, paginationService, cacheService) {

            searchService.get("reports/reportNames").then(function(response){
                $scope.names = response.data;
            });
            searchService.get("reports/reportIntervals").then(function(response){
                $scope.intervals = response.data
            });

            $scope.reset = function () {
                $scope.query = {
                    showTests: true,
                    showRecalculations: false,
                    limit: 20,
                    sortOrder: 'DESC'
                };
                return $scope.query;
            };
            $scope.query = cacheService.getObjectOrElse($scope.queryKey, $scope.reset)


            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getReports, $scope.key);
            }

            var getReports = function () {
                cacheService.registerObject($scope.queryKey, $scope.query)
                return searchService.get("reports" + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
                    $scope.reports = response.data.result;
                    $scope.selectedReports = [];
                    cacheService.registerObject("productFeeReportsTable", $scope.reports);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                    $scope.reports.forEach((report)=>{
                        report.isRecalculation = report.officialReportId !== undefined
                    })
                });
            }

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }
        }
    };
});
